export default __webpack_public_path__ + "static/media/Slide3.cf304d23.png";